// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zOfsICO341tteUV53iVt {
  display: grid;
  column-gap: 10px;
  row-gap: 20px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: auto auto;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/network/ThreatIntel/common/components/grid/grid-container.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,oDAAA;EACA,6BAAA;AAAF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.grid_container {\n  display: grid;\n  column-gap: 10px;\n  row-gap: 20px;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  grid-template-rows: auto auto;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid_container": `zOfsICO341tteUV53iVt`
};
export default ___CSS_LOADER_EXPORT___;
